export const GET_MEMBERS = 'GET_MEMBERS';
export const GET_MEMBERS_SUCCESS = 'GET_MEMBERS_SUCCESS';
export const GET_MEMBERS_FAILURE = 'GET_MEMBERS_FAILURE';
export const SET_INITIAL_MEMBERS = 'SET_INITIAL_MEMBERS';
export const INVITE_MEMBER = 'INVITE_MEMBER';
